module.exports = __webpack_public_path__ + "img/coupon_tutorial_lalamee03.cd138522.jpg";